import {Designer, LangObject, TGlobal, TLangType} from "@brg/api";
import {TLangObject} from "@brg/api/dist/api-core/types/Generic";
import {THEME_AVAILABILITY} from "./ThemeAvailability";
import {IDesignerLight} from "../common";

export enum LMSLessonType {
    /// Видео
    Video = 0,
    /// По дате
    WithDate = 1,
    /// Без даты
    WithoutDate = 2
}

export interface IThemeItem<T extends TLangType = TGlobal> {
    name: TLangObject<T>,
    numberOfClasses: number,
    needHomeWork: boolean,
    isManuallyEnabled?: boolean,
    longreadId?: string
    id?: string
    clientTempId?: string
    lmsLessonInfo?: any
}

export interface IButtons {
    hidden: boolean,
    href: string,
    text: LangObject[],
    textMobile: LangObject[],
    type: string
}

export interface IExamItem<T extends TLangType = TGlobal> {
    title: TLangObject<T>,
    enabled: boolean,
    longreadId?: string
    competitionId?: string
    date?: string | null
}

export interface ILMSModuleInfo<T extends TLangType = TGlobal> {
    teacherIds: string[],
    teachers?: Designer<'Global'>[],
    nextThemeAvailability: THEME_AVAILABILITY,
    disciplineId: string,
    nextModuleLink: string,
    moduleProjectId?: string,
    themeInfos: IThemeItem[],
    examInfo?: IExamItem,
    about: TLangObject<T>,
    buttons: IButtons[],
    title?: TLangObject<T>,
    startDate?: string | null,
    endDate?: string | null,
    tags?: any[],
    tagsIds?: string[],
    coverUrl?: string | null,
    isGradeFormulaEnabled?: boolean,
    preventConsultationSingUpDays?: number | null,
}

export interface ILesson<T extends TLangType = TGlobal> {
    id: string,
    moduleProjectId: string,
    themeId: string,
    start: string,
    end: string,
    groupIds: string[],
    lessonLink: string,
    lessonLinkText: TLangObject<T>,
    title: TLangObject<T>,
    type?: LMSLessonType,
    isFirst?: boolean
}

export interface ILMSModule<T extends TLangType = TGlobal> extends ILMSModuleInfo {
    moduleProjectId?: string,
}

export interface IHomeWork<T extends TLangType = TGlobal> {
    student: IDesignerLight,
    homeWork: {
        status: number;
        id: string,
        moduleProjectId: string,
        themeLongreadId: string,
        additionalPostIds: string[],
        additionalPosts: any[],
        post: any,
        postId: string,
        studentId: string,
        isDirty?: boolean,
        approve: {
            "isApprove": boolean,
            "comment": string,
            "teacherId": string,
            "approveDate": string,
            "score": number,
            "nominationType": number,
            "isRetake"?: boolean
        },
        created: string,
        updated: string
    }
}
export interface IHWork<T extends TLangType = TGlobal> {
        id: string,
        moduleProjectId: string,
        themeLongreadId: string,
        additionalPostIds: string[],
        additionalPosts: any[],
        post: any,
        postId: string,
        studentId: string,
        approve: {
            "isApprove": boolean,
            "comment": string,
            "teacherId": string,
            "approveDate": string,
            "score": number,
            "nominationType": number,
            "isRetake"?: boolean
        },
        created: string,
        updated: string
    }
import {Designer, LangObject, TGlobal, TLangType} from "@brg/api";
import {TLangObject} from "@brg/api/dist/api-core/types/Generic";
import {THEME_AVAILABILITY} from "./ThemeAvailability";
import {IDesignerLight} from "../common";

export enum LMSLessonType {
    /// Видео
    Video = 0,
    /// По дате
    WithDate = 1,
    /// Без даты
    WithoutDate = 2
}

export interface IThemeItem<T extends TLangType = TGlobal> {
    name: TLangObject<T>,
    numberOfClasses: number,
    needHomeWork: boolean,
    isManuallyEnabled?: boolean,
    longreadId?: string
    id?: string
    clientTempId?: string
    lmsLessonInfo?: any
}

export interface IButtons {
    hidden: boolean,
    href: string,
    text: LangObject[],
    textMobile: LangObject[],
    type: string
}

export interface IExamItem<T extends TLangType = TGlobal> {
    title: TLangObject<T>,
    enabled: boolean,
    longreadId?: string
    competitionId?: string
    date?: string | null
}

export interface ILMSModuleInfo<T extends TLangType = TGlobal> {
    teacherIds: string[],
    teachers?: Designer<'Global'>[],
    nextThemeAvailability: THEME_AVAILABILITY,
    disciplineId: string,
    nextModuleLink: string,
    moduleProjectId?: string,
    themeInfos: IThemeItem[],
    examInfo?: IExamItem,
    about: TLangObject<T>,
    buttons: IButtons[],
    title?: TLangObject<T>,
    startDate?: string | null,
    endDate?: string | null,
    tags?: any[],
    tagsIds?: string[],
    coverUrl?: string | null,
    isGradeFormulaEnabled?: boolean,
    preventConsultationSingUpDays?: number | null,
}

export interface ILesson<T extends TLangType = TGlobal> {
    id: string,
    moduleProjectId: string,
    themeId: string,
    start: string,
    end: string,
    groupIds: string[],
    lessonLink: string,
    lessonLinkText: TLangObject<T>,
    title: TLangObject<T>,
    type?: LMSLessonType,
    isFirst?: boolean
}

export interface ILMSModule<T extends TLangType = TGlobal> extends ILMSModuleInfo {
    moduleProjectId?: string,
}

export interface IHomeWork<T extends TLangType = TGlobal> {
    student: IDesignerLight,
    homeWork: {
        status: number;
        id: string,
        moduleProjectId: string,
        themeLongreadId: string,
        additionalPostIds: string[],
        additionalPosts: any[],
        post: any,
        postId: string,
        studentId: string,
        isDirty?: boolean,
        approve: {
            "isApprove": boolean,
            "comment": string,
            "teacherId": string,
            "approveDate": string,
            "score": number,
            "nominationType": number,
            "isRetake"?: boolean
        },
        created: string,
        updated: string
    }
}
export interface IHWork<T extends TLangType = TGlobal> {
        id: string,
        moduleProjectId: string,
        themeLongreadId: string,
        additionalPostIds: string[],
        additionalPosts: any[],
        post: any,
        postId: string,
        studentId: string,
        approve: {
            "isApprove": boolean,
            "comment": string,
            "teacherId": string,
            "approveDate": string,
            "score": number,
            "nominationType": number,
            "isRetake"?: boolean
        },
        created: string,
        updated: string
    }
